// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { TerceraLookup } from './TerceraLookup';
export class TerceraFontLookup extends TerceraLookup {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.items = ['Tahoma', 'Verdana', 'Times New Roman', 'Georgia', 'Courier New', 'Lucida Console'];
    }
    showForm() {
        if (!this.get('enabled')) {
            return;
        }
        const items = this.createMenuItems();
        const el = this.find('div');
        const elRect = el.getBoundingClientRect();
        const x = elRect.left + window.scrollX;
        const y = elRect.top + window.scrollY + elRect.height + 1;
        showContextMenu({
            x,
            y,
            minWidth: elRect.width,
            items,
            functions: {
                closeCallback: () => {
                    this.closeForm();
                }
            }
        });
        void this.set('isFormShowed', true);
    }
    createMenuItems() {
        const items = this.items;
        const menuItems = [];
        const callback = this.private_OnMenuItemSelected.bind(this);
        const len = items.length;
        for (let i = 0; i < len; i++) {
            const item = items[i];
            menuItems.push({
                type: NewContextMenuItemType.Default,
                text: item,
                tag: item,
                event: callback
            });
        }
        return menuItems;
    }
    getTypingLookupValueForSet(typedText) {
        const items = this.items;
        const len = items.length;
        let selectedItem = this.get('selectedItem');
        typedText = typedText.toUpperCase();
        for (let i = 0; i < len; i++) {
            const font = items[i];
            if (font.toUpperCase().indexOf(typedText) !== -1) {
                selectedItem = font;
                break;
            }
        }
        return selectedItem;
    }
    private_OnMenuItemSelected(menuItem) {
        void this.set('selectedItem', menuItem.tag);
    }
}
TerceraLookup.extendWith(TerceraFontLookup, {});
